/* istanbul ignore file */
import { shape, string, arrayOf, number, bool } from 'prop-types';

export default shape({
  dimensionName: string,
  label: string,
  type: string,
  tooltip: string,
  values: arrayOf(
    shape({
      name: string,
      value: string,
      quantity: number,
      selected: bool,
    })
  ),
});
